import { render, staticRenderFns } from "./stnAdd.vue?vue&type=template&id=007a84f1&scoped=true"
import script from "./stnAdd.vue?vue&type=script&lang=js"
export * from "./stnAdd.vue?vue&type=script&lang=js"
import style0 from "./stnAdd.vue?vue&type=style&index=0&id=007a84f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a84f1",
  null
  
)

export default component.exports